(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cp-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cp-sticky-atc')) {
    class CpStickyAtc extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('[data-cp-select]');
        this.priceEl = this.querySelector('[data-cp-price]');
        this.button = this.querySelector('[data-cp-button]');
        this.buttonLabel = this.button ? this.button.querySelector('span') : null;
        this.addLabel = this.buttonLabel ? this.buttonLabel.textContent.trim() : '';

        if (this.select) {
          this.select.addEventListener('change', () => this.updateFromSelect());
        }

        if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const variant = event && event.data ? event.data.variant : null;
            if (!variant || !this.select) return;
            this.select.value = String(variant.id);
            this.updateFromSelect();
          });
        }

        const mainButton = document.querySelector('.product-form__submit[id^="ProductSubmitButton-"]');
        if (mainButton && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            const entry = entries[0];
            const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.toggle(passed);
          });
          this.observer.observe(mainButton);
        } else {
          this.onScroll = () => this.toggle(window.scrollY > 600);
          window.addEventListener('scroll', this.onScroll, { passive: true });
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
        if (this.unsubscribe) this.unsubscribe();
      }

      toggle(show) {
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', show ? 'false' : 'true');
      }

      updateFromSelect() {
        const option = this.select.options[this.select.selectedIndex];
        if (!option) return;
        if (this.priceEl && option.dataset.price) this.priceEl.textContent = option.dataset.price;
        const available = option.dataset.available === 'true';
        if (!this.button) return;
        if (available) {
          this.button.removeAttribute('disabled');
          if (this.buttonLabel && this.addLabel) this.buttonLabel.textContent = this.addLabel;
        } else {
          this.button.setAttribute('disabled', 'disabled');
          if (this.buttonLabel && window.variantStrings) this.buttonLabel.textContent = window.variantStrings.soldOut;
        }
      }
    }
    customElements.define('cp-sticky-atc', CpStickyAtc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
